import { Dialog } from "@kobalte/core/dialog";
import { AnimateChildren } from "@storytell/ui/animation";
import { StButton } from "@storytell/ui/buttons";
import { TbInfoCircle, TbX } from "solid-icons/tb";
import type { Component } from "solid-js";

interface DeleteViewModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  viewName: string;
}

export const DeleteViewModal: Component<DeleteViewModalProps> = (props) => {
  return (
    <AnimateChildren show={props.isOpen} enter={{ opacity: [0, 1], y: [10, 0] }} exit={{ opacity: [1, 0], y: [0, 10] }}>
      {(anim) => (
        <Dialog
          open={anim.isMounted()}
          onOpenChange={(val) => {
            if (!val) props.onClose();
          }}
        >
          <Dialog.Portal>
            <Dialog.Overlay class="fixed z-90 inset-0 bg-black/50 dark:bg-white/10" />
            <div ref={anim.ref} class="fixed z-90 inset-0 flex items-center justify-center">
              <Dialog.Content class="max-h-[80vh] relative w-screen text-primary-text max-w-md bg-panel overflow-y-auto rounded-xl p-6">
                <Dialog.CloseButton as={StButton} class="absolute top-4 right-4">
                  <TbX />
                </Dialog.CloseButton>

                <div class="mb-6">
                  <h3 class="text-lg font-medium mb-4">
                    Delete the Collection <span class="font-bold">{props.viewName}</span>?
                  </h3>
                  <div class="bg-red-50 dark:bg-red-950/20 border border-red-200 dark:border-red-800 rounded-lg p-3">
                    <div class="flex items-center gap-2">
                      <span class="text-lg">🛑</span>
                      <p class="text-red-800 dark:text-red-200 text-sm">
                        Deleting <span class="font-bold">{props.viewName}</span> will remove this fence around your
                        data. The underlying filters and assets will not be deleted.
                      </p>
                    </div>
                  </div>
                </div>

                <div class="mb-4 flex justify-end">
                  <a
                    href="https://go.storytell.ai/learn-deleting-collections"
                    target="_blank"
                    rel="noopener noreferrer"
                    class="inline-flex items-center gap-1 underline text-brand text-xs"
                  >
                    <TbInfoCircle />
                    Learn about deleting Collections
                  </a>
                </div>

                <div class="flex items-center justify-end gap-3">
                  <StButton onClick={props.onClose} class="px-4 py-2 text-secondary-text hover:text-primary-text">
                    Cancel
                  </StButton>
                  <StButton onClick={props.onConfirm} class="px-4 py-2 text-white bg-red-600 hover:bg-red-700">
                    Yes, Delete Collection
                  </StButton>
                </div>
              </Dialog.Content>
            </div>
          </Dialog.Portal>
        </Dialog>
      )}
    </AnimateChildren>
  );
};
